import { listZipScpFiles } from './zipFiles.js';

export const MAX_PARSE_FILES = 10000;

export async function prepareImportSelection(selection) {
  const files = [];
  let skipped = 0;
  for (const value of Array.from(selection || [])) {
    const entry = value.file
      ? value
      : { file: value, relativePath: value.webkitRelativePath || value.name };
    if (/\.zip$/i.test(entry.file.name)) {
      const archive = await listZipScpFiles(entry.file, entry.relativePath);
      for (const candidate of archive.files) files.push(candidate);
      skipped += archive.skipped;
    } else if (/\.scp$/i.test(entry.file.name)) files.push(entry);
    else skipped += 1;
  }
  files.sort((a, b) => a.relativePath.localeCompare(b.relativePath, undefined, { numeric: true }));
  return { files, skipped };
}

export function chooseImportFiles(prepared, count) {
  return prepared.files.slice(
    0,
    Math.min(MAX_PARSE_FILES, count === 'all' ? prepared.files.length : count)
  );
}
